export var LocalStorageEnum;
(function (LocalStorageEnum) {
    LocalStorageEnum["Login"] = "Login";
    LocalStorageEnum["Url"] = "Url";
    LocalStorageEnum["SelectedJobID"] = "selectedJobID";
    LocalStorageEnum["SelectedModuleID"] = "selectedModuleID";
    LocalStorageEnum["IsLoggedIn"] = "IsLoggedIn";
})(LocalStorageEnum || (LocalStorageEnum = {}));
